import useOneOffTracking from './useOneOffTracking';

/**
 * Hook for implementing "one-off" pageviews. Only the first pageview is tracked.
 * To track a pageview, call `trackPageViewEvent` function. After the first call subsequent calls will be ignored.
 * To reset this behavior (clearing persistent data), call `resetCheck` function.
 * @param pageType GA Page Type
 * @returns {{ resetCheck: () => void; trackPageViewEvent: () => void; }}
 */
export default function useOneoffPageview(pageType: string) {
    const { resetPageViewCheck, trackPageViewEvent } = useOneOffTracking({ pageType });

    return { resetCheck: resetPageViewCheck, trackPageViewEvent };
}
